import React  from 'react';
import './App.css';
import { Route, Routes, Navigate} from 'react-router-dom'
import PrivateRoute from './modules/Auth/PrivateRoute';
import ProtectedRoute from './modules/Auth/ProtectedRoute';
import CheckAuth from './modules/Auth/authCheck';
import history from './modules/Navigation';
import Login from './pages/login/login'
import Home from './pages/backOffice/home/home';
import Licence from './pages/backOffice/licence/licence';
import Changepassword from './pages/backOffice/changepassword/changepassword';

// CheckAuth();
const App=()=> {
  return (
    <>
    <Routes history={history}> 
      {/* <Route  element={<ProtectedRoute />}>
        <Route exact path="/new-job" element={< NewJob/>}/>
        <Route exact path="/my-job" element={< MyJob/>}/>
        <Route exact path="/profile" element={<UserProfile />}/>
      </Route>
       */}
      
      {/* <Route  element={<PrivateRoute />}> */}
        <Route exact path="/" element={<Home />}/>
        <Route exact path="/licence" element={<Licence />}/>
        <Route exact path="/change-password" element={<Changepassword />}/>
      {/* </Route> */}

      
      {/* <Route exact path="/" element={< Login/>}/> */}
      
      

      <Route
        path="*"
        element={<Navigate to="/" replace />}
      />
    </Routes>
      
    </>
  );
};

export default App;
